import React from 'react';
import { motion } from 'motion/react';
import { Search, LayoutDashboard } from 'lucide-react';
import { UserProfile } from '../../types';

interface HeroProps {
  onSearch: (query: string) => void;
  user: UserProfile | null;
  onDashboard: () => void;
}

export const Hero = ({ onSearch, user, onDashboard }: HeroProps) => (
  <section className="pt-20 pb-32 px-4 overflow-hidden relative min-h-[600px] flex items-center justify-center">
    {/* Background Image - Clean fit without dark overlay */}
    <div className="absolute inset-0 z-0">
      <img 
        src="https://lh3.googleusercontent.com/d/15JXFspoxXc8dYuuQ8uZWhZq2tTdeYyMo" 
        alt="Hero Background"
        className="w-full h-full object-cover"
        referrerPolicy="no-referrer"
      />
    </div>

    <div className="max-w-4xl mx-auto relative z-10 w-full">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="bg-white/30 backdrop-blur-md p-5 xs:p-8 md:p-12 rounded-[2.5rem] md:rounded-[40px] border border-white/40 shadow-2xl shadow-slate-900/5 mx-2 xs:mx-0"
      >
        <div className="flex flex-wrap gap-2.5 mb-6">
          <span className="inline-block bg-emerald-500 text-white px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg shadow-emerald-500/25">
            #1 Marketplace Barber Premium
          </span>
          <span className="inline-block bg-rose-500 text-white px-4 py-1.5 rounded-full text-[10px] font-black uppercase tracking-widest shadow-lg shadow-rose-500/25">
            ✨ Kini Tersedia untuk Wanita
          </span>
        </div>
        <h1 className="text-[26px] xs:text-4xl sm:text-5xl md:text-6xl font-black text-slate-900 mb-6 tracking-tighter leading-[0.9]">
          <span className="block whitespace-nowrap">Cukur Online,</span>
          <span className="block whitespace-nowrap">
            <span className="text-emerald-500 italic">tunggu kami</span> dirumah
          </span>
        </h1>
        <p className="text-slate-600 text-lg md:text-xl max-w-2xl mb-10 font-medium leading-relaxed text-justify">
          Platform booking kapster profesional dengan layanan premium untuk pria & wanita. Pesan dari rumah, nikmati hasil guntingan terbaik dan modern.
        </p>

        {user && (
          <motion.div 
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            className="mb-10"
          >
            <button 
              onClick={onDashboard}
              className="group flex items-center gap-3 bg-emerald-500 hover:bg-emerald-600 text-white px-8 py-4 rounded-2xl font-black uppercase tracking-widest transition-all shadow-xl shadow-emerald-500/20 active:scale-95"
            >
              <LayoutDashboard className="w-5 h-5 group-hover:rotate-12 transition-transform" />
              Kembali Ke Dashboard
            </button>
          </motion.div>
        )}

        <div className="max-w-2xl mx-auto flex flex-col sm:flex-row items-stretch sm:items-center p-2 bg-white rounded-[2rem] sm:rounded-3xl border border-slate-200 focus-within:border-emerald-500 transition-all shadow-xl gap-2 sm:gap-0">
          <div className="flex-1 flex items-center px-4 gap-3">
            <Search className="w-5 h-5 text-slate-400 shrink-0" />
            <input 
              type="text" 
              placeholder="Cari kapster favorit..." 
              className="w-full bg-transparent border-none text-slate-900 focus:ring-0 text-sm py-3 font-bold"
            />
          </div>
          <button 
            className="bg-slate-900 hover:bg-slate-800 text-white px-8 py-4 sm:py-3 rounded-2xl text-[10px] font-black uppercase tracking-widest transition-all whitespace-nowrap active:scale-95 shadow-lg shadow-slate-900/20"
            onClick={() => onSearch('')}
          >
            Cari Sekarang
          </button>
        </div>
      </motion.div>
    </div>
  </section>
);
